import React, { Component, PropTypes } from 'react'
import { withRouter } from 'react-router'

import rebase from './rebase'

import './LoginView.css'

class LoginView extends Component {
  static propTypes = {
    router: PropTypes.object.isRequired
  }

  constructor() {
    super()

    this.state = { busy: true }
  }

  componentDidMount() {
    this.unsubscribe = rebase.onAuth((user) => {
      console.log('LoginView onAuth: ', user)

      if (user) {
        this.props.router.push('/')
      } else {
        this.setState({ busy: false })
      }
    })
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  handleLoginWithGoogle = event => {
    rebase.authWithOAuthRedirect('google', this.handleAuth)
  }

  handleLoginWithPassword = event => {
    event.preventDefault()

    const email = 'simonxwhite@gmail.com'
    const password = this.passwordRef.value

    rebase.authWithPassword({ email, password }, this.handleAuth)
  }

  handleAuth = (error, data) => {
    if (error) {
      console.error('error: ', error)
    }

    const errorMessage = error && error.message
    this.setState({ errorMessage })

    // console.log('data: ', data)
  }

  render() {
    if (this.state.busy) {
      return <h3>Authenticating...</h3>
    }

    return (
      <div>
        <div className="LoginView-section">
          <span className="LoginView-action" onClick={this.handleLoginWithGoogle}>Login with Google</span>
        </div>

        <div className="LoginView-section">or</div>

        <form className="LoginView-section" onSubmit={this.handleLoginWithPassword}>
          <input className="LoginView-password" type="password" placeholder="Password" ref={input => this.passwordRef = input} />
          <span className="LoginView-action" onClick={this.handleLoginWithPassword}>Login with Password</span>
        </form>

        <div className="LoginView-section">
          <span className="LoginView-error">{this.state.errorMessage}</span>
        </div>

      </div>
    )
  }
}

export default withRouter(LoginView)



/** WEBPACK FOOTER **
 ** ./src/LoginView.js
 **/